import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { EProcessStatus } from "core/dto";
import { AppRouterService, LoaderService, SnackbarService } from "core/services";
import { interval, take } from "rxjs";
import { designerPaths } from "../../../designer.paths";
import { JwtService } from "../../../global-services/jwt.service";
import { DsgDeepTranslationKey } from "../../../pipes/translate.pipe";

type LOIDCError = 'USER_HAS_NO_ROLE';

@Component({
  selector: 'ss-oidc-callback.mock',
  template: '<div></div>',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OidcCallbackMockComponent {

  readonly jwtSubject = this._jwtService.jwtSubject;
  readonly refreshTokenExistsSubject = this._jwtService.refreshTokenExistsSubject
  readonly #errorMessages: Record<LOIDCError, DsgDeepTranslationKey> = {
    USER_HAS_NO_ROLE: 'ss-auth.error.user-has-no-role'
  }

  constructor(

    private readonly _activatedRoute: ActivatedRoute,
    private readonly _router: Router,
    private readonly _jwtService: JwtService,
    private readonly _appRouterService: AppRouterService,
    private readonly _snackbarService: SnackbarService<DsgDeepTranslationKey>,
    private readonly _loaderService: LoaderService<DsgDeepTranslationKey>

  ) {


    const { queryParams } = this._activatedRoute.snapshot;

    const params = this.#cleanParams(queryParams)


    if (!params) {
      this._router.navigate([designerPaths.auth])
    }

    const { jwt, activityId, accessedRoutePath, error } = params;

    if (error) {

      this._snackbarService.open({
        type: 'error',
        message: this.#errorMessages[error as LOIDCError] || 'ss-general.error'
      })

      const id = this._loaderService.show({ text: 'ss-auth.oidc.error.redirect-message' })

      interval(10 * 1000).pipe(
        take(1),
        this._loaderService.disposeLoader(id)
      )
        .subscribe(() => {
          this._router.navigate([designerPaths.auth])
        })



      return;
    }



    if (!jwt) {
      this._router.navigate(['auth'])
    }

    this.jwtSubject.next(jwt);
    this.refreshTokenExistsSubject.next(true)

    interval(250).pipe(
      take(1)
    )
      .subscribe(() => {
        if (activityId) {
          this._appRouterService.navigateToViewer(activityId, false);
          return;
        }

        const redirectUrl: string = accessedRoutePath || [designerPaths.processOverview, EProcessStatus.WaitingForMe].join('/');
        this._router.navigate([redirectUrl])
      })



  }


  #cleanParams(params: Record<string, string>) {
    if (!params) {
      return null
    }

    return Object.fromEntries(
      Object.entries(params).map(([key, value]) => [key, value === 'null' ? null : value])
    )
  }



}
